import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-arrow-lg-top",
  "use": "app-icon-arrow-lg-top-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-arrow-lg-top\"><path fill=\"#4D84FF\" d=\"M8 3.67L.76 10.92l1.41 1.41L8 6.5l5.83 5.83 1.41-1.41L8 3.67z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol